<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-地图服务-添加
    -->
    <el-dialog
    title="添加地图服务"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="地图服务名称" prop="name">
    <el-input v-model="form.name" placeholder="请输入地图服务名称" class="max-w460"></el-input>
  </el-form-item>

    <el-form-item label="备注" prop="remark">
    <el-input v-model="form.remark" placeholder="请输入备注" class="max-w460"></el-input>
  </el-form-item>

     <!-- <el-form-item label="优惠比例(%)" prop="discount">
    <el-input-number 
      v-model="form.discount" 
      :min="0" 
      :max="100" 
      :precision="2" 
      placeholder="请输入优惠比例" 
      class="max-w460">
      <template #append>%</template>
    </el-input-number>
  </el-form-item> -->
  
  <el-form-item label="原价" prop="price">
    <el-input-number v-model="form.price" :min="0" :precision="2" placeholder="请输入原价" class="max-w460"></el-input-number>
  </el-form-item>
  
  <el-form-item label="优惠价" prop="yprice">
    <el-input-number v-model="form.yprice" :min="0" :precision="2" placeholder="请输入优惠价" class="max-w460"></el-input-number>
  </el-form-item>
  
  <el-form-item label="优惠结束时间" prop="ytime">
    <el-date-picker
      v-model="form.ytime"
      type="datetime"
      placeholder="选择优惠结束时间"
      value-format="yyyy-MM-dd HH:mm:ss"
      class="max-w460">
    </el-date-picker>
  </el-form-item>
  
<el-form-item label="关联平台" prop="platformms">
  <el-checkbox-group v-model="form.platformms" class="platform-checkbox-group">
    <el-checkbox 
      v-for="platform in platformOptions"
      :key="platform.platformm_id"
      :label="platform.platformm_id"
      class="platform-checkbox"
    >
      {{ platform.name }}
    </el-checkbox>
  </el-checkbox-group>
</el-form-item>
  
  <el-form-item label="月销" prop="sales">
    <el-input-number v-model="form.sales" :min="0" placeholder="请输入月销量" class="max-w460"></el-input-number>
  </el-form-item>
  
  <el-form-item label="虚拟月销" prop="xsales">
    <el-input-number v-model="form.xsales" :min="0" placeholder="请输入虚拟月销量" class="max-w460"></el-input-number>
  </el-form-item>
  
  <el-form-item label="好评率(%)" prop="rate">
    <el-input-number 
      v-model="form.rate" 
      :min="0" 
      :max="100" 
      :precision="2" 
      placeholder="请输入好评率" 
      class="max-w460">
      <template #append>%</template>
    </el-input-number>
  </el-form-item>

      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--商品图片组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>
import DserviceApi from '@/api/dservice.js';

import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
         /*是否上传图片*/
         isupload: false,
          platformOptions:[],
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
           discount:0,
        image:[],
        // categorya:{},
        sort:50,
         platformms: [] ,
        intro:"",
        bannar:[]
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入地图服务名称', trigger: 'blur' }],
         platformms: [
    { type: 'array', message: '必须为数组格式', trigger: 'change' }
  ]
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album"
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
      this.getList()
  },
  props: ["open_add"],
  methods: {
        getList(){
      DserviceApi.getPlatformm().then((res=>{
        this.platformOptions = res.data.list.data
        console.log('data',this.platformOptions);
      }))
    },
       togglePlatform(platformId) {
      const index = this.form.platformms.indexOf(platformId)
      if (index > -1) {
        // 如果已选中，则移除
        this.form.platformms.splice(index, 1)
      } else {
        // 如果未选中，则添加
        this.form.platformms.push(platformId)
      }
      console.log(this.form.platformms);
      
    },
    // 选择变化时的回调
    handlePlat(value) {
      console.log('当前选中的平台:', value)
      // 这里可以添加其他处理逻辑
    },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
  
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          DserviceApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}
.platform-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-width: 460px;
}

.platform-checkbox {
  margin-right: 15px;
  margin-bottom: 10px;
}

.platform-checkbox:deep(.el-checkbox__label) {
  padding-left: 5px;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/dservice/index/part/add.vue